var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "dropdown fpdates",
      class: { selected: _vm.dateValues != null },
    },
    [
      _c(
        "button",
        { staticClass: "dropdown__button", on: { click: _vm.openFlatpickr } },
        [_vm._v(_vm._s(_vm.dateStr))]
      ),
      _vm._v(" "),
      _c("flat-pickr", {
        ref: "flatpickr",
        attrs: { config: _vm.config },
        model: {
          value: _vm.dateValues,
          callback: function ($$v) {
            _vm.dateValues = $$v
          },
          expression: "dateValues",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }